import { createAction, props } from '@ngrx/store';
import { StudySearchStrategy } from '../../../../models/searchStrategy.model';
import { StudySearchFilter } from '../../../../models/studySearchFilter.model';
import { FilterCriteria } from '../../../add-filter-dialog/shared/filter-criteria.model';
import { SearchStrategyCreate } from '../models/search-strategy-create.model';
import { SearchStrategyUpdateResponse } from '../models/search-strategy-update-response.model';
import { SearchStrategyUpdate } from '../models/search-strategy-update.model';

export const createSearchStrategy = createAction('[Search Strategy Component] Create Search Strategy', props<{ data: SearchStrategyCreate }>());

export const saveSearchStrategy = createAction('[Search Strategy Component] Save Search Strategy', props<{ data: SearchStrategyUpdate }>());

export const updateSearchStrategyAfterExecution = createAction(
  '[Search Strategy Component] Update Search Strategy After Execution',
  props<{ results: string; resultsCount: number; totalCount?: number; filters: StudySearchFilter[] }>()
);

export const addSearchFilter = createAction('[Add Filter Dialog Component] Add Filter', props<{ filter: StudySearchFilter }>());

export const updateSearchFilter = createAction(
  '[Add Filter Dialog Component] Update Filter',
  props<{ id: number; json: string; filterCriteria: FilterCriteria }>()
);

export const searchStrategyCreated = createAction('[Search Strategy Effects] Search Strategy Created', props<{ response: StudySearchStrategy }>());

export const searchStrategyCreateFailed = createAction('[Search Strategy Effects] Search Strategy Create Failed');

export const searchStrategyUpdated = createAction(
  '[Search Strategy Effects] Search Strategy Updated',
  props<{ response: SearchStrategyUpdateResponse }>()
);

export const searchStrategyUpdateFailed = createAction('[Search Strategy Effects] Search Strategy Update Failed');

export const deleteSearchFilter = createAction('[Search Strategy Component] Remove Filter', props<{ filterId: number }>());

export const singleSearchFilterAvailabilityChanged = createAction(
  '[Search Strategy Component] Single Search Filter Availability Changed',
  props<{ filterId: number; active: boolean }>()
);

export const allSearchFiltersAvailabilityChanged = createAction(
  '[Search Strategy Component] All Search Filters Availability Changed',
  props<{ active: boolean }>()
);

export const setSearchFiltersAsActive = createAction(
  '[Search Strategy Component] Set Search Filters As Active',
  props<{ filterIds: number[]; isBooleanSearchChanged: boolean }>()
);
